import { OptimizelyExperiments } from 'constants/optimizely'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import getOfferCtaText from 'lib/offer/getOfferCtaText'

export default function useOfferCtaText() {
  const variant = useOptimizelyExperiment(OptimizelyExperiments.croOfferCtaText)
  return getOfferCtaText(variant)
}
